import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentBox } from "@msuite/ui/content-box";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { useParams } from "react-router";
import { Can } from "@/components/citadel";
import { VehicleHeader } from "@/components/vehicles";
import { VehicleDocuments } from "./panels/vehicle-documents";
import { VehicleGeneral } from "./panels/vehicle-general";
import { VehicleOrders } from "./panels/vehicle-orders";
import { VehicleMenu } from "./vehicle-menu";

export function Vehicle() {
	/** Hooks */
	const params = useParams<{ vehicleId: string }>();
	const { t } = useTranslation();
	const vehicleId = params.vehicleId;

	/** Gaurd */
	if (!vehicleId) return null;

	/** Render */
	return (
		<ContentBox bottomPadding="none">
			{/* One rule covers the whole page: every panel on it reads the lorry, and `Vehicle`
			    reaches the whole fleet or none of it. */}
			<Can
				action="read"
				subject="Vehicle"
				fallback={
					<BlankSlate
						Icon={icon("Car")}
						label={t("general.no_access")}
					/>
				}
			>
				<VehicleHeader vehicleId={vehicleId} />
				<Tabs
					header={() => <VehicleMenu vehicleId={vehicleId} />}
					groups={[
						{
							name: "general",
							panels: [
								{
									label: t("general.general"),
									cyId: "vehicle-general-tab",
									panel: () => <VehicleGeneral vehicleId={vehicleId} />,
									errors: [],
								},
							],
						},
						{
							name: "information",
							panels: [
								{
									label: t("vehicles.orders"),
									cyId: "vehicle-orders-tab",
									panel: () => <VehicleOrders vehicleId={vehicleId} />,
									errors: [],
								},
								{
									label: t("documents.documents"),
									cyId: "vehicle-documents-tab",
									panel: () => <VehicleDocuments vehicleId={vehicleId} />,
									errors: [],
								},
							],
						},
					]}
				/>
			</Can>
		</ContentBox>
	);
}
